import {
  Card,
  Col,
  Row,
  Tooltip,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import { useState, useRef, useEffect, lazy, Suspense, useMemo } from "react";
import { ReactComponent as CloseIcon } from "../../../assests/close-icon.svg";
import "./LocationList.css";

const { Text } = Typography;

// Lazy load DMAList
const DMAList = lazy(() => import("../dma-list/DmaList"));

const LocationsList = ({ showNearby, placement, exposeClearFunction }) => {
  const [activePopover, setActivePopover] = useState(null);
  const btnRefs = useRef({});
  const popoverRef = useRef(null);

  const handleButtonClick = (key) => {
    const btn = btnRefs.current[key];
    if (!btn) return;

    setActivePopover((prev) => (prev === key ? null : key));
  };

  const hidePopover = () => setActivePopover(null);

  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      !Object.values(btnRefs.current).some((btn) => btn.contains(event.target))
    ) {
      hidePopover();
    }
  };

  useEffect(() => {
    if (activePopover) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [activePopover]);

  const popoverTitle = useMemo(
    () => (
      <Row>
        <Col span={22}>
          <Text className="loc-popover-title">More Locations</Text>
        </Col>
        <Col span={2} style={{ textAlign: "center" }}>
          <CloseIcon onClick={hidePopover} style={{ cursor: "pointer" }} />
        </Col>
      </Row>
    ),
    []
  );

  return (
    <div
      className={` ${
        placement === "productpage"
          ? "product-placement-container"
          : "map-placement-container"
      }`}
    >
      {["DMA"]?.map((label) => (
        <div
          key={label}
          ref={(el) => (btnRefs.current[label] = el)}
          onClick={() => handleButtonClick(label)}
          className="location-list-view-text"
        >
          {placement === "productpage" ? (
            showNearby ? (
              <>
                <Tooltip
                  styles={{
                    body: { color: "#fff" },
                  }}
                  title={
                    <pre className="tooltip-product-card">
                      Disable Nearby Products when DMAs are selecting{" "}
                    </pre>
                  }
                >
                  <Text
                    className="location-list-view-span"
                    disabled={showNearby}
                  >
                    View More
                  </Text>
                </Tooltip>
              </>
            ) : (
              <>
                <Text className="location-list-view-span">View More</Text>
              </>
            )
          ) : (
            <div className="filter-div-at-map-section">
              <Text className="filter-sec-at-map-txt">{label}</Text>
            </div>
          )}
        </div>
      ))}

      {activePopover && (
        <div
          ref={popoverRef}
          className={` ${
            placement === "productpage" ? "product-placement" : "map-placement"
          }`}
        >
          <Card
            title={popoverTitle}
            style={{ width: 600 }}
            className="location-list-card"
          >
            <Suspense fallback={<div>Loading locations...</div>}>
              <DMAList exposeClearFunction={exposeClearFunction} />
            </Suspense>
          </Card>
        </div>
      )}
    </div>
  );
};

export default LocationsList;
